/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineAgentsService
 */

export const BreezeAgentToolTypename = 'com.hubspot.breeze.engine.data.models.BreezeAgentTool';
export const BreezeChirpToolTypename = 'com.hubspot.breeze.engine.data.models.BreezeChirpTool';
export const BreezeKnowledgeVaultToolTypename = 'com.hubspot.breeze.engine.data.models.BreezeKnowledgeVaultTool';
export const listAgentsRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineAgentsService',
  rpcName: 'listAgents',
  auth: 'app',
  fingerprint: 'TUomi6rvl9SngRSKPulCR050XaVubBSy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};